import { Certification } from 'app/types/reviews';

export function getCompletedCertifications(certifications: Certification[] | undefined) {
  return certifications?.filter((cert) => cert.status === 'certified');
}
